export default __webpack_public_path__ + "static/headstand-shoulderstrength-3-d5d01be0144c22f8e11166fb98984560.jpg";